import { render, staticRenderFns } from "./GroupIndicatorsValuePage.vue?vue&type=template&id=54f345e5&"
import script from "./GroupIndicatorsValuePage.vue?vue&type=script&lang=ts&"
export * from "./GroupIndicatorsValuePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports